/*
 * RAEN collection-card colour swatches (ported from live 3.0.1).
 *
 * Clicking a colour swatch on a product card swaps the card over to that
 * colourway in place: primary and hover images, frame / lens text, price, the
 * card's links and its quick view. The payload is rendered on each swatch by
 * snippets/custom-color-swatch.liquid.
 *
 * Delegated from document so cards injected later (Nosto dynamic product
 * cards, AJAX collection tabs) work too. If a card is missing a piece the swap
 * needs, the click falls through and the swatch link navigates as before.
 */
(() => {
  const setImage = (img, src, srcset) => {
    if (!img || !src) return;
    img.src = src;
    img.srcset = srcset || '';
    // A card that hasn't lazy-loaded yet would otherwise restore the old image.
    if (img.dataset.src) img.dataset.src = src;
    if (img.dataset.srcset) img.dataset.srcset = srcset || '';
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.custom-swatch[data-handle]');
    if (!swatch) return;

    const card = swatch.closest('product-card');
    const primaryImage = card && card.querySelector('.product-primary-image');
    const { image1, image1Srcset, image2, image2Srcset } = swatch.dataset;
    if (!primaryImage || !image1) return;

    event.preventDefault();

    // Every link in the card that points at the current product follows the swap.
    const current = card.dataset.swatchPath || new URL(primaryImage.closest('a').href).pathname;
    const next = new URL(swatch.href).pathname;
    card.querySelectorAll('a[href]:not(.custom-swatch)').forEach((link) => {
      const url = new URL(link.href);
      if (url.pathname !== current) return;
      url.pathname = next;
      link.href = url.toString();
    });
    card.dataset.swatchPath = next;

    setImage(primaryImage, image1, image1Srcset);
    setImage(card.querySelector('.product-secondary-image'), image2, image2Srcset);

    const frameColor = card.querySelector('.frame-and-lens .frame-color');
    const lensColor = card.querySelector('.frame-and-lens .lens-color');
    if (frameColor && swatch.dataset.frameColor) frameColor.textContent = swatch.dataset.frameColor;
    if (lensColor && swatch.dataset.lensColor) lensColor.textContent = swatch.dataset.lensColor;

    // The compare-at price only exists on the card while the colourway is on sale.
    const price = card.querySelector('.product-price .price');
    if (price && swatch.dataset.price) {
      price.textContent = swatch.dataset.price;
      let comparePrice = price.parentElement.querySelector('.compare-price');
      if (swatch.dataset.comparePrice) {
        if (!comparePrice) {
          comparePrice = document.createElement('span');
          comparePrice.className = 'compare-price';
          price.before(comparePrice);
        }
        comparePrice.textContent = swatch.dataset.comparePrice;
      } else if (comparePrice) {
        comparePrice.remove();
      }
    }

    card.querySelectorAll('quick-view.product-card-quickview').forEach((quickView) => {
      quickView.dataset.productHandle = swatch.dataset.handle;
    });
  });
})();
